module.exports = __webpack_public_path__ + "static/media/009.72e456e9.jpg";